import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const SuccessPopup = ({ message, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">Success</h3>
        <p className="popup-message">{message}</p>

        <Link to="/patient/myappointments" className="popup-link">
          Click here to view your appointments
        </Link>

        <button className="popup-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessPopup;
